<main class="table-page table-page--fill" dir="rtl">
<header class="header"><div class="title-row">
    <button class="back" type="button" aria-label="بازگشت" (click)="goBack()"><i class="fa fa-arrow-right"></i></button>
    <div class="title-block"><h1 class="title">لیست درآمدها</h1></div>
    <div class="actions"><button class="btn btn-ghost" type="button" [disabled]="loading" [attr.aria-expanded]="filtersOpen" (click)="filtersOpen = !filtersOpen"><i class="fa fa-filter"></i> فیلتر <span class="badge" [class.show]="hasRecordFilters">{{ hasRecordFilters ? '۱' : '' }}</span></button><span class="actions-sep"></span><button class="btn-round btn-round-primary" type="button" aria-label="افزودن" data-tip="افزودن" [disabled]="loading" (mouseenter)="pageTooltip.show($event, 'افزودن')" (mouseleave)="pageTooltip.hide()" (focus)="pageTooltip.show($event, 'افزودن')" (blur)="pageTooltip.hide()" data-bs-toggle="modal" data-bs-target="#exampleModal" (click)="open()"><i class="fa fa-plus"></i></button></div>
  </div><div class="collapsible" [class.collapsed]="!filtersOpen"><div class="collapsible-inner"><div class="filters">
    <fieldset class="field border-0 p-0 m-0" [formGroup]="dataAz" [disabled]="loading"><span class="field-label">تاریخ شروع</span><ng-persian-datepicker   [uiTheme]="'gray'" [timeEnable]="false" [dateInitValue]="false" [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true" [dateFormat]="'jYYYY/jMM/jDD'" [dateGregorianFormat]="'YYYY/MM/DD'"><input class="control" formControlName="date" readonly aria-label="تاریخ شروع"></ng-persian-datepicker></fieldset>
    <fieldset class="field border-0 p-0 m-0" [formGroup]="datatTa" [disabled]="loading"><span class="field-label">تاریخ پایان</span><ng-persian-datepicker   [uiTheme]="'gray'" [timeEnable]="false" [dateInitValue]="false" [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true" [dateFormat]="'jYYYY/jMM/jDD'" [dateGregorianFormat]="'YYYY/MM/DD'"><input class="control" formControlName="date" readonly aria-label="تاریخ پایان"></ng-persian-datepicker></fieldset>
    <fieldset class="field border-0 p-0 m-0" [formGroup]="serchModel" [disabled]="loading"><span class="field-label">توضیحات</span><input class="control" formControlName="strComment" placeholder="توضیحات درآمد"></fieldset>
    <div class="filter-actions"><button class="btn btn-primary" type="button" [disabled]="loading" (click)="serch()"><i class="fa fa-search"></i> جستجو</button><button class="btn btn-ghost" type="button" *ngIf="hasRecordFilters" [disabled]="loading" (click)="resetRecordFilters()"><i class="fa fa-undo"></i> حذف فیلترها</button></div>
  </div></div></div></header>
<section class="card">
    <div class="table-toolbar">
        <label class="search-wrap">
            <input class="control" type="search" [(ngModel)]="searchText" (ngModelChange)="onSearchChange()"
                placeholder="جستجو در جدول: تاریخ، مبلغ، توضیحات..." [disabled]="loading">
            <i class="fa fa-search"></i>
        </label>
        <div class="toolbar-actions">
            <button class="btn btn-soft" type="button" ngxPrint [useExistingCss]="true" [printTitle]="tableTitle"
                [printSectionId]="printId" [disabled]="loading || hasError || !filteredRows.length">
                <i class="fa fa-print"></i> چاپ
            </button>
            <button class="btn btn-soft" type="button" (click)="exportExcel()" [disabled]="loading || hasError || !filteredRows.length">
                <i class="fa fa-file-excel-o"></i> خروجی اکسل
            </button>
        </div>
    </div>
    <div class="body">
        <div class="loader" [class.show]="tableLoading" role="status" aria-live="polite">
            <div class="spinner"></div><span>در حال دریافت اطلاعات…</span>
        </div>
        <div class="state" [class.show]="!tableLoading && !hasError && !filteredRows.length">
            <div class="ico-big"><i class="fa fa-inbox"></i></div>
            <h4>{{ emptyTitle }}</h4>
            <span class="muted">{{ hasActiveFilters ? 'فیلترها را تغییر دهید و دوباره جستجو کنید.' : 'هنوز اطلاعاتی ثبت نشده است.' }}</span>
            <div class="empty-actions" *ngIf="hasActiveFilters">
                <button class="btn btn-primary" type="button" [disabled]="loading" (click)="clearSearch()"><i class="fa fa-undo"></i> حذف فیلترها</button>
            </div>
        </div>
        <div class="state error" [class.show]="!tableLoading && hasError">
            <div class="ico-big"><i class="fa fa-exclamation-triangle"></i></div>
            <h4>دریافت اطلاعات با خطا مواجه شد</h4>
            <span class="muted">{{ errorMessage }}</span>
            <button class="btn btn-primary retry" type="button" [disabled]="loading" (click)="getAllIncom()"><i class="fa fa-refresh"></i> تلاش مجدد</button>
        </div>
        <div class="table-scroll" *ngIf="!hasError && filteredRows.length" [hidden]="tableLoading" (scroll)="pageTooltip.hide()">
            <ng-container [ngTemplateOutlet]="recordsTable"
                [ngTemplateOutletContext]="{ data: pagedRows, offset: (currentPage - 1) * pageSize, printing: false }"></ng-container>
        </div>
    </div>
    <app-table-pagination [page]="currentPage" [pageSize]="pageSize" [totalItems]="filteredRows.length"
        [pageSizeOptions]="pageSizeOptions" (pageChange)="onPageChange($event)" (pageSizeChange)="onPageSizeChange($event)"></app-table-pagination>
</section>
<div class="print-only" [id]="printId" *ngIf="!tableLoading && !hasError && filteredRows.length">
    <div class="table-page" dir="rtl">
        <h1 class="title">{{ tableTitle }}</h1>
        <ng-container [ngTemplateOutlet]="recordsTable"
            [ngTemplateOutletContext]="{ data: filteredRows, offset: 0, printing: true }"></ng-container>
    </div>
</div>
<ng-template #recordsTable let-data="data" let-offset="offset" let-printing="printing">
            <table>
                <thead>
                    <tr>
                        <th *ngIf="!printing" class="col-ops sticky-first">عملیات</th>
                        <th class="col-num">#</th>
                        <th>تاریخ</th>
                        <th class="col-amt">مبلغ (تومان)</th>
                        <th>توضیحات</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let row of data; let i = index">
                        <td *ngIf="!printing" class="col-ops sticky-first">
                            <div class="row-ops">
                                    <button class="ico" type="button" [disabled]="loading" aria-label="مشاهده و ویرایش درآمد" data-tip="مشاهده و ویرایش درآمد"
                                        (mouseenter)="pageTooltip.show($event, 'مشاهده و ویرایش درآمد')" (mouseleave)="pageTooltip.hide()"
                                        (focus)="pageTooltip.show($event, 'مشاهده و ویرایش درآمد')" (blur)="pageTooltip.hide()"
                                        (click)="pageTooltip.hide(); onRecordAction('edit', row)">
                                        <i class="fa fa-pencil"></i>
                                    </button>
                            </div>
                        </td>
                        <td class="col-num">{{ offset + i + 1 | faNum }}</td>
                        <td>{{ row.strDate | faNum }}</td>
                        <td class="col-amt">{{ numberValue(row.iAmount) | number:'1.0-2' | faNum }}</td>
                        <td>{{ row.strComment | faNum }}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr>
                        <td *ngIf="!printing" class="sticky-first"></td>
                        <td class="label" colspan="2">تعداد کل: {{ filteredRows.length | number | faNum }}</td>
                        <td class="col-amt">{{ totalAmount | number:'1.0-2' | faNum }} تومان</td>
                        <td></td>
                    </tr>
                </tfoot>
            </table>
</ng-template>
<div class="modal fade rtl" id="exampleModal" tabindex="-1" aria-labelledby="incomeModalTitle" aria-describedby="incomeModalHint" aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header align-items-start">
        <div>
          <h2 class="modal-title" id="incomeModalTitle">{{ EditeMod ? 'ویرایش درآمد' : 'ثبت درآمد' }}</h2>
          <p class="muted mb-0 mt-2" id="incomeModalHint">تاریخ و مبلغ درآمد را وارد کنید. مبلغ‌ها به تومان هستند.</p>
        </div>
        <button class="btn-close p-3" type="button" data-bs-dismiss="modal" aria-label="بستن"></button>
      </div>
      <div class="modal-body" [attr.aria-busy]="loading">
        <fieldset class="row g-3 border-0 p-0 m-0" [formGroup]="sabtModel" [disabled]="loading">
          <div class="field col-12 col-md-6" [formGroup]="datasabt">
            <label class="field-label" for="incomeDate">تاریخ <span class="text-danger">*</span></label>
            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateInitValue]="false" [uiHideAfterSelectDate]="true" [uiHideOnOutsideClick]="true" [dateFormat]="'jYYYY/jMM/jDD'" [dateGregorianFormat]="'YYYY/MM/DD'">
              <input id="incomeDate" class="control" formControlName="date" readonly aria-label="تاریخ درآمد">
            </ng-persian-datepicker>
          </div>
          <label class="field col-12 col-md-6" for="incomeAmount">
            <span class="field-label">مبلغ (تومان) <span class="text-danger">*</span></span>
            <input id="incomeAmount" class="control" type="text" inputmode="numeric" formControlName="iAmount" (keypress)="seprator($event)" aria-describedby="incomeAmountHint" placeholder="مبلغ درآمد">
            <small class="muted" id="incomeAmountHint">مبلغ را به تومان وارد کنید، نه ریال.</small>
          </label>
          <label class="field col-12" for="incomeComment">
            <span class="field-label">توضیحات <span class="muted">(اختیاری)</span></span>
            <textarea id="incomeComment" class="control" rows="4" formControlName="strComment" placeholder="بابت چه موردی درآمد ثبت می‌شود؟"></textarea>
          </label>
        </fieldset>
        <p *ngIf="loading" class="muted mt-3 mb-0" role="status" aria-live="polite">در حال پردازش اطلاعات درآمد…</p>
      </div>
      <div class="modal-footer gap-2">
        <button class="btn btn-ghost" type="button" *ngIf="!EditeMod" data-bs-dismiss="modal">بستن</button>
        <button class="btn btn-ghost text-danger" type="button" *ngIf="EditeMod" [disabled]="loading" (click)="deleteIncom()">حذف</button>
        <button class="btn btn-primary" type="button" [disabled]="loading" (click)="EditeMod ? edit() : sabt()">{{ EditeMod ? 'ویرایش' : 'ذخیره' }}</button>
      </div>
    </div>
  </div>
</div>
<app-table-tooltip #pageTooltip></app-table-tooltip>
</main>
